module.exports = __webpack_public_path__ + "img/ennetix-transactions-stats.4dc10c7e.png";